import {Component} from '@angular/core';
/**
 * \@title Basic tooltip
 */
export class TooltipOverviewExample {static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'tooltip-overview-example',
  templateUrl: 'tooltip-overview-example.html',
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function TooltipOverviewExample_tsickle_Closure_declarations() {
/** @type {?} */
TooltipOverviewExample.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TooltipOverviewExample.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
